/* =============================================================
 * import
 * ========================================================== */
import {gsap} from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

/* =============================================================
 * export function
 * ========================================================== */
export function routeCommonBefore(data) { // eslint-disable-line @typescript-eslint/no-unused-vars
                                          // 次ページの用意が整った段階
                                          // 遷移前ページデータ：data.current
                                          // 遷移後ページデータ：data.next
                                          // console.log(data);
}


export function routeCommonAfter(data) { // eslint-disable-line @typescript-eslint/no-unused-vars
                                         // 次ページの用意が整った段階
                                         // 遷移後ページデータ：data.next
                                         // console.log(data);

  bottomLayerAnimation();
  moonPin(data);
  negativeHeader();

}


function bottomLayerAnimation() {
  const trigger = document.querySelector('.js-footer_trigger');
  const content = document.querySelector('.js-footer_content');

  // Follow Sidebar
  if (trigger && content) {

    gsap.from(content, {
      // borderRadius: '0px 0px 0px 0px',
      y: '-50%',
      scrollTrigger: {
        trigger: trigger,
        start: 'bottom bottom', // content viewport
        endTrigger: content,
        end: 'bottom bottom',
        // pin: content,
        // pinSpacing: false,
        scrub: true,
        invalidateOnRefresh: true, // update on resize
      },
    });

  }
}


function moonPin(data) {
  const triggerStart = document.querySelector('.vs-pax-container');
  const triggerEnd = data.next.container.querySelector('.js-footer_trigger');
  const content = data.next.container.querySelector('.js-moon');

  // Follow Sidebar
  if (triggerStart && triggerEnd && content) {

    gsap.from(content, {
      scrollTrigger: {
        trigger: triggerStart,
        start: 'top top', // content viewport
        endTrigger: triggerEnd,
        end: 'center center',
        pin: content,
        pinSpacing: false,
        scrub: true,
        invalidateOnRefresh: true, // update on resize
        onEnter: () => {
          const pinSpacer = content.parentNode;
          if (pinSpacer && pinSpacer.classList.contains('pin-spacer')) {
            pinSpacer.style.mixBlendMode = window.getComputedStyle(content).getPropertyValue('mix-blend-mode');
            pinSpacer.style.pointerEvents = window.getComputedStyle(content).getPropertyValue('pointer-events');
          }
        },
        onUpdate: () => {
          const pinSpacer = content.parentNode;
          if (pinSpacer && pinSpacer.classList.contains('pin-spacer')) {
            pinSpacer.style.mixBlendMode = window.getComputedStyle(content).getPropertyValue('mix-blend-mode');
            pinSpacer.style.pointerEvents = window.getComputedStyle(content).getPropertyValue('pointer-events');
          }
        },
      },
    });


    // 背景の月
    /*
    const moon = content.querySelector('.moon_sphere');
    if (moon) {
      gsap.to(moon, {
        backgroundColor: '#212121',
        scrollTrigger: {
          trigger: triggerEnd,
          start: 'top center', // content viewport
          endTrigger: triggerEnd,
          end: 'top top',
          scrub: true,
          invalidateOnRefresh: true, // update on resize
        },
      });
    }
    */

    // マウスストーカー
    const moonStalker = content.querySelector('.moon_stalker');
    if (moonStalker) {

      const links = document.querySelectorAll('a.footer_nav_list_item_link, a.header_nav_list_item_link, a.footer_nav_list_child_item_link, a.header_nav_list_child_item_link'); // 対象のリンク要素のクラスを指定

      links.forEach(link => {
        link.addEventListener('mouseenter', () => {
          const linkRect = link.getBoundingClientRect();
          const contentRect = content.getBoundingClientRect();
          const moonStalkerRect = moonStalker.getBoundingClientRect();

          // ストーカーの位置を計算
          const x = linkRect.left + (linkRect.width / 2) - contentRect.left - (moonStalkerRect.width / 2);
          const y = linkRect.top + (linkRect.height / 2) - contentRect.top - (moonStalkerRect.height / 2);

          let bgColor = '#F6F7F8';
          if (link.classList.contains('footer_nav_list_item_link') || link.classList.contains('footer_nav_list_child_item_link')) {
            bgColor = '#212121';
          }

          // ストーカーをアニメーションで移動
          gsap.to(moonStalker, {
            x: x,
            y: y,
            backgroundColor: bgColor,
            opacity: 1,
            duration: 0.5,
            ease: "power2.out",
          });
        });

        link.addEventListener('mouseleave', () => {
          // ストーカーを非表示にする
          gsap.to(moonStalker, {
            opacity: 0,
            duration: 0.5,
            ease: "power2.out",
          });
        });
      });
    }
  }
}


function negativeHeader() {
  const header = document.querySelector('.header');
  const darkSections = document.querySelectorAll('.dark');

  darkSections.forEach(section => {
    ScrollTrigger.create({
      trigger: section,
      start: 'top top', // セクションがヘッダーと交差するポイント
      end: 'bottom top', // セクションがヘッダーから離れるポイント
      onEnter: () => header.classList.add('negative'),
      onLeaveBack: () => header.classList.remove('negative'),
      onEnterBack: () => header.classList.add('negative'),
      onLeave: () => header.classList.remove('negative'),
    });
  });


}